import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const CookiePolicy = () => {
  return (
    <>
      <Helmet>
        <title>Cookie Policy - Ganda Sushi</title>
      </Helmet>

      <main className="bg-luxury-cream text-luxury-dark pt-40 pb-24">
        <section className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="prose prose-gold max-w-none"
          >
            <h1 className="text-5xl font-serif text-luxury-gold mb-12 uppercase tracking-tight">Cookie Policy</h1>
            <p className="text-luxury-dark/60 italic mb-12 border-l-2 border-luxury-gold pl-6">Effective Date: January 27, 2025</p>

            <div className="space-y-12 text-luxury-dark/70 leading-relaxed font-light">
              <p>
                Our digital platform utilizes cookies to provide a refined browsing experience. These small identifiers allow us to remember your preferences and optimize our site's performance.
              </p>
              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">Management</h2>
                <p>
                  Patrons may manage their cookie preferences through their browser settings. However, please be advised that disabling certain cookies may affect the fluidity of our digital interface.
                </p>
              </section>
            </div>
          </motion.div>
        </section>
      </main>
    </>
  );
};

export default CookiePolicy;